// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrintButton-CSATPopup-wrapper {
  position: absolute;
  bottom: 100;
  right: 0;
  width: 528px;
  background-color: var(--color_neutral_200);
  padding: 32px;
  border-radius: 4px;
  z-index: 999;
}
.PrintButton-CSATPopup-wrapper .answeredTitle {
  color: var(--color_neutral_800);
  font-size: 24px;
  text-align: center;
}
.PrintButton-CSATPopup-wrapper .titleRow {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
}
.PrintButton-CSATPopup-wrapper .titleRow button {
  position: absolute;
  top: -16px;
  right: -16px;
}
.PrintButton-CSATPopup-wrapper .titleRow button svg path {
  fill: var(--color_neutral_800);
}
.PrintButton-CSATPopup-wrapper .inputSection {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}
.PrintButton-CSATPopup-wrapper .inputSection span {
  color: var(--color_neutral_500);
}
.PrintButton-CSATPopup-wrapper .buttonSection {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.confirmation.PrintButton-CSATPopup-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
}
.confirmation.PrintButton-CSATPopup-wrapper [class^=dist_buttonStyle] svg {
  height: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/PrintButton/components/CSATPopup/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;AAEI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAAN;AAIQ;EACE,8BAAA;AAFV;AAQE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AANJ;AAQI;EACE,+BAAA;AANN;AAUE;EACE,eAAA;EACA,aAAA;EACA,yBAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AATF;AAYI;EACE,uBAAA;AAVN","sourcesContent":[".PrintButton-CSATPopup-wrapper {\n  position: absolute;\n  bottom: 100;\n  right: 0;\n  width: 528px;\n  background-color: var(--color_neutral_200);\n  padding: 32px;\n  border-radius: 4px;\n  z-index: 999;\n\n  .answeredTitle {\n    color: var(--color_neutral_800);\n    font-size: 24px;\n    text-align: center;\n  }\n\n  .titleRow {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    position: relative;\n    width: 100%;\n\n    button {\n      position: absolute;\n      top: -16px;\n      right: -16px;\n\n      svg {\n\n        path {\n          fill: var(--color_neutral_800);\n        }\n      }\n    }\n  }\n\n  .inputSection {\n    font-size: 12px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 2px;\n\n    span {\n      color: var(--color_neutral_500);\n    }\n  }\n\n  .buttonSection {\n    margin-top: 8px;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.confirmation.PrintButton-CSATPopup-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 16px;\n\n  [class^=\"dist_buttonStyle\"] {\n    svg {\n      height: 14px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
